/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
    questionnaire,
    endorsmentType
  }) {
    return questionnaire.map(question => {

        if([2080].includes(question.idQuestion)) {
            if(endorsmentType !== 'declaration') { 
              question.behaviorObject.isRequired = false;
              question.visibleQuestion = false;
            }
          }

          
      return question;
    })
  };
  
  async function handleQuestionChange({
    question,
    value,
    questionnaireUpdated,
    setQuestionnaireUpdated,
    setFieldValue,
    globalQuestionnaire,
  }) {
    try {
      let saveQuestionnaire = false;
  
      if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);
  
    } catch (e) {
      console.log('TEMPLATE DECLARATION - handleQuestionChange - error', e)
    }
  };
  
  function handleQuestionBlur({
    question,
    value,
    setFieldValue,
    formikRef,
    obligorGroup,
    setObligorGroup,
    index,
    values,
    setMaxValuePerc,
    mask,
    maskPercentage,
  }) {
    try {
  
    } catch (e) {
      console.log("TEMPLATE DECLARATION - handleQuestionBlur error", e)
    }
  }

  
  const events = {
    handleInitialAdjustments,
    handleQuestionChange,
    handleQuestionBlur,
  };
  
  export { events };